module.exports = __webpack_public_path__ + "img/img_no3.9c03105c.png";